import {
  ScreenViewScreenData,
  createScreenViewEvent,
} from '@moonpig/web-core-analytics'
import { BRAND_LABEL } from '@moonpig/web-core-brand/config'
import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql/graphqlTypes'
import { AddonsFieldsFragment } from '../queries/useProductWithAddonsQuery/__generated__/useProductWithAddonsQuery'
import { isCardProduct } from '../utils/isCardProduct'

export type VariantInfo = {
  addons?: AddonsFieldsFragment[] | null
}

type ProductInfo = {
  id: string
  category: string
  title: string
  variantTitle: string
  price: number
  isLandscape?: boolean
  categoryDepartment?: string
}

type ScreenViewGAEventProps = {
  product: ProductInfo
  productDetailsPageUrlFromModal?: string
}

export const createScreenViewWithProductsGAEvent = ({
  product,
  productDetailsPageUrlFromModal,
}: ScreenViewGAEventProps) => {
  const screenClass = productDetailsPageUrlFromModal
    ? 'product details | popup'
    : 'product details'
  const productTitle = product.title
  const screenData: ScreenViewScreenData = {
    renderType: productDetailsPageUrlFromModal ? 'client' : 'server',
    documentReferrer: productDetailsPageUrlFromModal
      ? document.location.href
      : document.referrer,
    documentTitle: `${productTitle} | ${BRAND_LABEL}`.toLowerCase(),
    documentUrl: productDetailsPageUrlFromModal || document.location.href,
  }

  let product_orientation: string | undefined
  if (
    isCardProduct(product.categoryDepartment as DepartmentsEnum) &&
    typeof product.isLandscape === 'boolean'
  ) {
    product_orientation = product.isLandscape ? 'landscape' : 'portrait'
  }

  const productData = {
    product_brand: BRAND_LABEL.toLowerCase(),
    product_category: product.category,
    product_id: product.id,
    product_name: product.title.toLowerCase(),
    product_variant: product.variantTitle.toLowerCase(),
    product_price: product.price / 100,
    product_quantity: 1,
    product_orientation,
  }

  return createScreenViewEvent({
    screenClass,
    screenName: `${screenClass} | ${productTitle}`.substring(0, 100),
    screenData,
    productData,
  })
}
